// import React from "react";

// const Section2 = ({ data }) => {
//   let color = ["#F3FBFD","#FCF6EE","#F5F5FE"];

//   let border ={
//     F3FBFD:"#ABD4E0",
//     F5F5FE:"#ABACE0",
//     FCF6EE:"#E0C9AB"
//   }
// let newColor=""
//   const getRandomColor = (lastColor) => {
//     // Filter out the last color so it's not included in the available options
//     const availableColors = color.filter((color) => color !== lastColor);

//     // Pick a random color from the remaining available colors
//     newColor =availableColors[Math.floor(Math.random() * availableColors.length)];

//     return newColor;
//   };

//   return (
//     <div className="w-full flex justify-center">
//       <div className="2xl:container w-full flex flex-col py-[72px] md:px-10 lg:px-20  px-6">
//         <div className="text-24 md:text-32 lg:text-40 text-center text-21273D font-medium">
//           {data.services ? <h1 className="text-24 md:text-36 lg:text-48 text-primaryColor font-semibold">{data.services.title}</h1> : ""}
//         </div>
//         <div className="w-full grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8 md:mt-16 ml-auto">
//           {data.services
//             ? data.services.list.map((service, ind) => {
//                 const previousColor = newColor;
//                 const randomColor = getRandomColor(previousColor);
//                 return (
//                   <div
//                     key={ind}
//                     className="p-6 rounded-[24px] flex flex-col gap-6 border-[1px]  "
//                     style={{
//                       backgroundColor: randomColor,
//                       borderColor: `#${border[randomColor.replace("#", "")]?.replace("#", "")}`,
//                     }}   >
//                       <div className="flex gap-3 items-center">
//                         <img src={process.env.PUBLIC_URL + service.icon} alt="icon" />
//                         <h1 className="text-20 text-primarycolor font-semibold">
//                       {service.heading}
//                     </h1>
//                       </div>
                   
//                     <p className="text-16 text-secondaryblack font-regular  ">
//                       {service.desc}
//                     </p>
//                   </div>
//                 );
//               })
//             : ""}
//         </div>
//       </div>
//     </div>
//   );
// };

const Section2 = ({ data }) => {
  const colors = ["#F5F5FE","#F3FBFD", "#FCF6EE", ];
  const border = {
    F3FBFD: "#ABD4E0",
    F5F5FE: "#ABACE0",
    FCF6EE: "#E0C9AB"
  };

  const columns = 3; // number of columns per row

  return (
    <div className="w-full flex justify-center">
      <div className="2xl:container w-full flex flex-col py-[72px] md:px-10 lg:px-20  px-6">
        <div className="text-24 md:text-32 lg:text-40 text-center text-21273D font-medium">
          {data.services && (
            <h1 className="text-24 md:text-36 lg:text-48 text-primaryColor font-semibold">
              {data.services.title}
            </h1>
          )}
        </div>

        <div className="w-full grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8 md:mt-16 ml-auto">
          {data.services &&
            data.services.list.map((service, ind) => {
              const rowIndex = Math.floor(ind / columns);
              const colIndex = ind % columns;

              // Rotate colors for each row: shift left by rowIndex positions
              const rotatedColors = colors
                .slice(rowIndex % colors.length)
                .concat(colors.slice(0, rowIndex % colors.length));

              const cardColor = rotatedColors[colIndex];
              const cardBorder = border[cardColor.replace("#", "")];

              return (
                <div
                  key={ind}
                  className="p-6 rounded-[24px] flex flex-col gap-6 border-[1px]"
                  style={{
                    backgroundColor: cardColor,
                    borderColor: cardBorder
                  }}
                >
                  <div className="flex gap-3 items-center">
                    <img
                      src={process.env.PUBLIC_URL + service.icon}
                      alt="icon"
                    />
                    <h1 className="text-20 text-primarycolor font-semibold">
                      {service.heading}
                    </h1>
                  </div>
                  <p className="text-16 text-secondaryblack font-regular">
                    {service.desc}
                  </p>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};



export default Section2;